import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * SSO istemcisi — standart OIDC (oidc-client-ts), Keycloak'a özel adapter
 * DEĞİL. Bilinçli: müşteri IdP'leri Keycloak'a broker olarak bağlanacak
 * (Kapsam §4.4 — sınırsız çoklu IdP) ve SPA her durumda yalnızca bizim
 * realm'imizle konuşacak; standart OIDC bunu değişiklik gerektirmeden taşır.
 *
 * Akış: Authorization Code + PKCE (oidc-client-ts'in varsayılanı; realm'de
 * S256 zorunlu kılındı — docker/keycloak/isg-realm.json).
 */
const issuer: string =
  (import.meta.env['VITE_KEYCLOAK_ISSUER_URL'] as string | undefined) ??
  'http://localhost:8080/realms/isg';

export const userManager = new UserManager({
  authority: issuer,
  client_id: 'isg-web',
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  // sessionStorage: token sekme ömrüyle sınırlı kalsın (bilinçli — kalıcı
  // oturum bir ürün kararı olarak verilmedi).
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // OTURUM YENİLEME (F1·S10): access token dolmadan refresh token'la
  // arka planda yenilenir — kullanıcı ekran başındayken oturum kopmaz.
  // Refresh de dolarsa kullanıcı signed_out durumuna düşer ve giriş
  // ekranına döner (sessiz sonsuz oturum YOK — bilinçli).
  automaticSilentRenew: true,
});
